import { ItemChartModel } from '../global/item-chart.model';

export class DevolutionChartModel {
  devolutionTotal: number = 0;
  devolutionStates: ItemChartModel[] = [];
  predevolutionTotal: number = 0;
  predevolutionStates: ItemChartModel[] = [];
}
